export default __webpack_public_path__ + "9eaa50662ef5446cf46c15ec76df5061.png";